import React from 'react';

import { LocalisedValue as ILocalisedServerValue } from '@lib/types';
import { useTranslation } from '@providers/I18n';

type LocalisedServerValueProps = {
  value: ILocalisedServerValue;
};

export const LocalisedServerValue: React.FC<LocalisedServerValueProps> = ({
  value,
}) => {
  const { i18n } = useTranslation();

  if (!value) {
    return null;
  }

  return (
    <>
      {i18n.language === 'ar'
        ? value.arName ?? '---'
        : value.enName ?? '---'}
    </>
  );
};
